/**
 * @generated SignedSource<<0a3edf016a899d3d75458498cc495547>>
 * @relayHash 2630c316156787421a031d387edd687f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID faf8688ca6a479ce3109ec4b04745ef9b73151dc6cd4e440d1dee96343c43dbc

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiFeaturesPlansSettingsQuery } from './uiFeaturesPlansSettingsQuery.graphql';

const node: PreloadableConcreteRequest<uiFeaturesPlansSettingsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "faf8688ca6a479ce3109ec4b04745ef9b73151dc6cd4e440d1dee96343c43dbc",
    "metadata": {},
    "name": "uiFeaturesPlansSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
